import {
  Spaceable
} from "./chunk.G3SZKTQJ.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  h,
  ke
} from "./chunk.FCKNEYTX.js";
import {
  n
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.I4IFG4JG.js";

// src/components/jb-article-tool-bar/jb-article-tool-bar.scss?inline
var jb_article_tool_bar_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

:host {
  --button-width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
@media (min-width: 960px) {
  :host {
    flex-direction: row;
    gap: var(--spacing-m);
    --button-width: auto;
  }
}

jb-article-share-bar {
  justify-content: center;
  margin-block-start: var(--spacing-m);
}
@media (min-width: 960px) {
  jb-article-share-bar {
    justify-content: start;
    margin-block-start: initial;
  }
}

@media print {
  :host {
    display: none;
  }
}`;

// src/components/jb-article-tool-bar/jb-article-tool-bar.ts
var JbArticleToolBar = class extends Spaceable(h) {
  _getContentSpacingProperties() {
    return { type: "half-top-no-bottom", grid: "legacy" };
  }
  _handleClick(icon) {
    if (icon === "jb-mail-icon") {
      this.dispatchEvent(
        new CustomEvent("jbNewsletterOverlayPopupOpen", {
          bubbles: true,
          composed: true
        })
      );
    }
  }
  render() {
    return ke`
      <jb-button-panel>
        ${this.buttons.map(
      (item) => ke`
            <jb-button-secondary @click=${this._handleClick.bind(this, item.icon)}>
              ${item.icon === "jb-mail-icon" ? ke`<jb-mail-icon></jb-mail-icon>` : D}
              ${item.label}</jb-button-secondary
            >
          `
    )}
      </jb-button-panel>
      <jb-article-share-bar
        .ariaLabelShareOnFacebook=${this.ariaLabelShareOnFacebook}
        .ariaLabelShareOnLinkedin=${this.ariaLabelShareOnLinkedin}
        .ariaLabelShareOnMail=${this.ariaLabelShareOnMail}
        .ariaLabelShareOnX=${this.ariaLabelShareOnX}
        .articleTitle=${this.articleTitle}
        .mailSubject=${this.mailSubject}
        .title=${this.shareBarLabel}
        .url=${this.url}
      ></jb-article-share-bar>
    `;
  }
};
JbArticleToolBar.styles = r(jb_article_tool_bar_default);
__decorateClass([
  n()
], JbArticleToolBar.prototype, "ariaLabelShareOnFacebook", 2);
__decorateClass([
  n()
], JbArticleToolBar.prototype, "ariaLabelShareOnLinkedin", 2);
__decorateClass([
  n()
], JbArticleToolBar.prototype, "ariaLabelShareOnMail", 2);
__decorateClass([
  n()
], JbArticleToolBar.prototype, "ariaLabelShareOnX", 2);
__decorateClass([
  n()
], JbArticleToolBar.prototype, "articleTitle", 2);
__decorateClass([
  n({ type: Array })
], JbArticleToolBar.prototype, "buttons", 2);
__decorateClass([
  n()
], JbArticleToolBar.prototype, "mailSubject", 2);
__decorateClass([
  n()
], JbArticleToolBar.prototype, "shareBarLabel", 2);
__decorateClass([
  n()
], JbArticleToolBar.prototype, "url", 2);
JbArticleToolBar = __decorateClass([
  customElement("jb-article-tool-bar")
], JbArticleToolBar);

export {
  JbArticleToolBar
};
